// import React from 'react'
// import OnlineRoomSchedule from './online-room-schedule'

// export default class OrionsRevengeOnlineSchedule extends OnlineRoomSchedule {
//   renderHelpers () {
//     return (
//       <div className="helpers">
//         <div className="no_strangers_notice helper">
//           All games are private, only your team is allowed in the room,
//           <span className="color_text">NO&nbsp;STRANGERS.</span>
//         </div>

//         <div className="game_cost helper">
//           <div className="label">Wednesday - Sunday</div>
//           <div className="value">2-8 connections</div>
//         </div>
//       </div>
//     )
//   }
// }
import React from 'react'
import { HTTPError } from 'lib/ky'
import moment from 'lib/moment-timezone-custom'
import OrderItem from 'models/order-item'
import RoomSchedule from 'frontend/schedule/room-schedule'
import RoomWeekSelect from 'frontend/schedule/room-week-select'
import CommonIcons from 'frontend/components/common-icons'
import ScheduleWeek from 'frontend/schedule/schedule-week'

export default class OrionsRevengeOnlineSchedule extends RoomSchedule {
  constructor (props) {
    super(props)

    this.state.showOptionsModal = false
  }

  handleSlotSelect (params) {
    const { timeSlot, playersCount, complete, game } = params

    if (game) {
      this.redirectToOrder()
      return
    }

    if (timeSlot.time <= moment()) {
      complete && complete()
      return
    }

    this.setState({
      selectedPlayersCount: playersCount,
      selectedSlot: timeSlot,
      selectedRoom: timeSlot.room,
      selectedTime: timeSlot.time
    }, () => {
      if (timeSlot.status === 'available') {
        this.submit(params)
      } else {
        this.handleUnavailableSlot(params)
      }
    })
  }

  submit ({ complete, ...params }) {
    const { selectedPlayersCount } = this.state

    if (selectedPlayersCount) {
      this.addToOrder({ complete, ...params })
    } else {
      this.setState({ showOptionsModal: true })
      complete && complete()
    }
  }

  async addToOrder ({ complete, success }) {
    const { selectedPlayersCount, selectedSlot: timeSlot } = this.state
    const { order } = this.state

    let orderItem = this.findOrderItem({ order, timeSlot })

    if (!orderItem) {
      orderItem = this.buildOrderItem({ order, timeSlot })
      order.items.push(orderItem)
    }

    orderItem.orderableStore = {
      playersCount: selectedPlayersCount
    }

    try {
      this.handlePushOrderResponse({ order: await order.push(), success })
    } catch (e) {
      this.handleAddToOrderError(e)
    } finally {
      complete && complete()
    }
  }

  handlePushOrderResponse ({ order, success }) {
    if (order.hasErrors) {
      if (order.hasGamesItemsMixedError || order.hasMixedLocationsError) {
        this.setState({ showProceedWithRoomModal: true })
      } else {
        this.setState({ errorMessage: order.fullErrorMessages })
      }
    } else {
      this.setState({ showAddedToOrderModal: true })
      success && success()
    }

    this.populateCartItems(order)
    this.setState({ order })
  }

  async handleAddToOrderError (e) {
    if (e instanceof HTTPError) {
      const response = await e.response.json()

      if (e.error) {
        this.setState({ errorMessage: response.error })
        return
      }
    }

    throw e
  }

  findOrderItem ({ order, timeSlot }) {
    const { room, time } = timeSlot

    return order.items.find(item => {
      return item.orderable &&
        item.orderable.roomId === room.id &&
        time.diff(item.orderable.reservedTo) === 0
    })
  }

  buildOrderItem ({ order, timeSlot }) {
    const { room, time, gameId } = timeSlot
    const { selectedPlayersCount } = this.state

    return new OrderItem({
      attrs: {
        orderableType: 'Game',
        orderableId: gameId,
        orderable: {
          roomId: room.id,
          reservedTo: time.toString()
        },
        orderableStore: {
          playersCount: selectedPlayersCount
        }
      },
      parent: order
    })
  }

  async handleGameRemove ({ timeSlot, complete }) {
    const { order } = this.state
    const item = this.findOrderItem({ order, timeSlot })

    await item.delete()
    order.items = order.items.filter(other => other.id !== item.id)
    this.populateCartItems(order)
    this.setState({ order }, complete)
  }

  handleUnavailableSlot ({ timeSlot, complete }) {
    this.setState({
      unavailableSlot: timeSlot,
      showSuggestions: true
    }, complete)
  }

  renderFilters () {
    const { selectedDate } = this.state

    return (
      <div className="filters">
        <div className="select_date">
          <h4 className="title">
            Select date
          </h4>
          <RoomWeekSelect
            selected={selectedDate}
            onChange={this.handleDateSelect.bind(this)}
          />
        </div>
      </div>
    )
  }

  renderSchedule () {
    return (
      <ScheduleWeek
        room={this.state.schedule}
        hidePrice={!!this.state.prebooking}
        schedule={this.state.schedule}
        selectedDate={this.state.selectedDate}
        selectedTime={this.state.selectedTime}
        selectedRoom={this.state.selectedRoom}
        selectedPlayersCount={this.state.selectedPlayersCount}
        cartItems={this.state.cartItems}
        onSlotSelect={this.handleSlotSelect.bind(this)}
        onGameRemove={this.handleGameRemove.bind(this)}
        onPlayersCountSelect={this.handlePlayersCountSelect.bind(this)}
        showAdvanceDiscount={false}
      />
    )
  }

  renderHelpers () {
    const { schedule: { maxPlayers } } = this.state

    return (
      <div className="helpers">
        <div className="game_cost helper">
          <CommonIcons item="common-calendar-alt-r" className="icon" width={18} height={14} />
          <div className="value">
            <span style={{ textDecorationLine: 'line-through' }}>$20</span> $15 per player
          </div>
        </div>

        <div className="min_age helper">
          <CommonIcons item="common-child" className="icon" width={18} height={14} />
          <div className="value">
            Minimum age 15 years
          </div>
        </div>

        <div className="players_count helper">
          <CommonIcons item="common-users" className="icon" width={18} height={14} />
          <div className="value">Up to {maxPlayers} players</div>
        </div>
      </div>
    )
  }
}
